import { render } from "./FrontPageAccomplishments.vue?vue&type=template&id=ca987608"
const script = {}

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__